import $ from 'jquery'

// https://www.tiny.cloud/docs/integrations/bootstrap/
// Prevent Bootstrap dialog from blocking focusin
$(document).on('focusin', (e) => {
  if ($(e.target).closest('.tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root').length) {
    e.stopImmediatePropagation()
  }
})
